import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCalendar4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"calendar-4, date"} maskId="square-filled-radius-0-stroke-1-IconCalendar4"><path d="M7 4H3V21H21V4H17V2H16V4H8V2H7V4Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCalendar4;
